<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-12-15 16:31:43
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-01-22 00:39:40
-->
<template>
  <img
    src="https://manage.fankeymice.com/logo.png"
    @click="toGit"
  />
</template>

<script>
export default {
  name: "GitControl",
  methods: {
    toGit() {
      // console.log("toGit");

      // window.open("https://github.com/wangyuan389/mall-cook", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 30px;
  margin-right: 15px;
  cursor: pointer;
}
</style>